

























import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component({
  name: 'BlogTagList',
  components: {}
})
export default class extends Vue {
  @Prop() tags
}
